
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2063","transform":"translate(-1639 -6037)"}},[_c('circle',{attrs:{"data-name":"Ellipse 300","cx":"22","cy":"22","r":"22","transform":"translate(1639 6037)","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 75","d":"M1675.025 6059.42v9.7h-5.625v-9.05c0-2.273-.812-3.824-2.848-3.824a3.076 3.076 0 00-2.884 2.056 3.849 3.849 0 00-.187 1.371v9.447h-5.621s.075-15.327 0-16.915h5.625v2.4c-.011.019-.027.038-.038.055h.038v-.055a5.584 5.584 0 015.068-2.793c3.7 0 6.473 2.417 6.473 7.612zm-23.057-15.371a2.93 2.93 0 10-.067 5.855h.036a2.931 2.931 0 10.038-5.846zm-2.842 25.071h5.621v-16.915h-5.621z"}})])])
          )
        }
      }
    